import { faArrowRightFromBracket, faBars, faBell, faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useRef, useState } from 'react'
import '../../../App.css';
import { useNavigate } from 'react-router-dom';


export default function HeaderDashboard({ active, setActive }) {
  const [Sidebar, setSidebar] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const navigate = useNavigate();

  const handleSidebar = () => {
    setSidebar(!Sidebar);
  };

  const handleClickOutside = (event) => {
    if (
      Sidebar &&
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target)
    ) {
      setSidebar(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [Sidebar]);

  const Sidebarnav = [
    { id: 'div1', label: 'Overview', icon: 'Overview.svg' },
    { id: 'div2', label: 'Transactions', icon: 'menu.svg' },
    { id: 'div3', label: 'Change password', icon: 'Goal.svg' },
  ];

  const Sidebar_mobile_nav = [
    { id: 'div5', label: 'Users data', icon: 'Overview.svg' },
    { id: 'div6', label: 'Transaction History', icon: 'menu.svg' },
  ];

  const handleLogout = () => {
    sessionStorage.removeItem('admin');
    localStorage.removeItem('token');
    navigate('/admin/login');
  };

  return (
    <div className='border-b border-[#E8E8E8] px-5 md:px-7 py-3'>
      <div className='flex justify-between items-center'>
        <div className='flex items-center gap-4'>
          <div className={`block lg:hidden`}>
            <FontAwesomeIcon icon={faBars} className="py-3 text-xl" onClick={handleSidebar} ref={buttonRef} />
          </div>
          {Sidebar && (
            <div
              className={`absolute left-0 top-24 z-50 px-5 py-3 w-[90%] md:w-[50%] fade-in-left`}
              ref={dropdownRef}
            >
              <ul className="space-y-2 font-medium bg-[#191919] h-full py-5 2xl:py-10 flex flex-col">
                <div className=" flex items-center justify-center gap-2">
                  <div>
                    <img src="../assets/Logo/logo.svg" className="w-14" />
                  </div>
                  <div>
                    <p className="font-bold text-lg font-Artemus ">Stabilix</p>
                  </div>
                </div>
                {/* <div className="flex flex-1 w-full">
                  <div className="w-full mt-5 text-base 2xl:text-lg px-5 2xl:px-7 space-y-3">
                    {Sidebarnav.map((item) => (
                      <button
                        key={item.id}
                        className={`w-full text-start rounded-md ${active === item.id ? 'bg-[#856E4F] ' : ''}`}
                        onClick={() => { handleSidebar(); setActive(item.id) }}
                      >
                        <div className="py-2 2xl:py-3 px-3 2xl:px-7 flex items-center gap-5">
                          <img src={`/assets/other/${item.icon}`}></img>
                          {item.label}
                        </div>
                      </button>
                    ))}
                  </div>
                </div> */}


                <div className="flex flex-1 w-full">
                  <div className="w-full mt-5 text-base 2xl:text-lg px-5 2xl:px-7 space-y-3">
                    <div className='flex justify-center'><p className='border-b px-2'>Web App</p></div>
                    {Sidebarnav.map((item) => (
                      <button
                        key={item.id}
                        className={`w-full text-start rounded-md ${active === item.id ? 'bg-[#856E4F] ' : ''}`}
                        onClick={() => { setActive(item.id); setSidebar(false) }}
                      >
                        <div className="py-2 2xl:py-3 px-3 2xl:px-7 flex items-center gap-5">
                          <img src={`/assets/other/${item.icon}`}></img>
                          {item.label}
                        </div>
                      </button>
                    ))}
                    <div className='flex justify-center'><p className='border-b px-2'>Mobile App</p></div>
                    {Sidebar_mobile_nav.map((item) => (
                      <button
                        key={item.id}
                        className={`w-full text-start rounded-md ${active === item.id ? 'bg-[#856E4F] ' : ''}`}
                        onClick={() => { setActive(item.id); setSidebar(false) }}
                      >
                        <div className="py-2 2xl:py-3 px-3 2xl:px-7 flex items-center gap-5">
                          <img src={`/assets/other/${item.icon}`}></img>
                          {item.label}
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
                <button onClick={handleLogout} className='flex items-center gap-5 py-2 2xl:py-3 duration-500 hover:bg-white/5 rounded-md mx-5 2xl:mx-7 px-4 2xl:px-7'>
                  <FontAwesomeIcon icon={faArrowRightFromBracket} />
                  <p>Logout</p>
                </button>
              </ul>
            </div>
          )}
          <div className='border border-[#666666] text-[#666666] rounded-full w-10 h-10 grid place-content-center'>
            <FontAwesomeIcon icon={faUser} />
          </div>
          <p className='text-lg font-medium'>Hello Admin</p>
        </div>
        <div>
          <div className='relative cursor-pointer notify'>
            <FontAwesomeIcon icon={faBell} className='text-[#666666]' />
            <div className='w-1 h-1 rounded-md bg-[#299D91] absolute top-[1px] right-0'></div>
          </div>
        </div>
      </div>
    </div>
  )
}
